export const DEFAULT_PAGE_SIZE_FOR_HTTP_CALL = 1000000;
